import ApiService from "../../../services/ApiService";

async function assertOk(request) {
    const result = await request;
    if (result?.code && result.code !== "SUCCESS") {
        throw new Error(result.message || "Request failed");
    }
    return result;
}

const AdminGridPackService = {
    list: async () => {
        const result = await assertOk(ApiService.getData("/v1/puzzle/grid-pack"));
        return result?.items || [];
    },

    members: async (code) => {
        const result = await assertOk(ApiService.getData(`/v1/puzzle/grid-pack/${encodeURIComponent(code)}/members`));
        return result?.items || [];
    },

    mini: async (code, page, pageSize, keyword, excludePacked = false) => {
        const result = await assertOk(ApiService.getData(`/v1/puzzle/grid-pack/${encodeURIComponent(code)}/mini`, {
            page,
            pageSize,
            keyword: keyword ? encodeURIComponent(keyword) : "",
            excludePacked: Boolean(excludePacked),
        }));
        return result;
    },

    fill: async (tplId) =>
        assertOk(ApiService.postData(`/v1/puzzle/grid-pack/tpl/${tplId}/fill`, {})),

    add: async (code, tplId) =>
        assertOk(ApiService.postData(`/v1/puzzle/grid-pack/${encodeURIComponent(code)}/tpl/${tplId}`, {})),

    remove: async (code, tplId) =>
        assertOk(ApiService.deleteData(`/v1/puzzle/grid-pack/${encodeURIComponent(code)}/tpl/${tplId}`)),

    reorder: async (code) =>
        assertOk(ApiService.putData(`/v1/puzzle/grid-pack/${encodeURIComponent(code)}/reorder`, {})),
};

export default AdminGridPackService;
